import React, { useState, useEffect } from 'react';
import { get, post, put } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Orders() {
  const { hasPermission } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);

  const load = () => {
    setLoading(true);
    get('/orders').then(d => setOrders(d.data)).finally(() => setLoading(false));
  };
  useEffect(() => {
    load();
    get('/customers').then(d => setCustomers(d.data));
    get('/products').then(d => setProducts(d.data));
  }, []);

  return (
    <div>
      <div className="flex-between mb-lg">
        <h2 className="page-title">Sales Orders</h2>
        {hasPermission('orders:write') && (
          <button className="btn btn-primary" onClick={() => setModal({})}>+ New Order</button>
        )}
      </div>
      <div className="tbl-wrap">
        {loading ? <div className="spinner"></div> : (
          <table>
            <thead><tr><th>Order #</th><th>Date</th><th>Customer</th><th>Product</th><th>Qty</th><th>Delivery</th><th>Status</th></tr></thead>
            <tbody>
              {orders.length === 0
                ? <tr><td colSpan="7"><div className="empty-state"><h3>No orders yet</h3></div></td></tr>
                : orders.map(o => (
                  <tr key={o.id}>
                    <td style={{fontWeight:500}}>{o.order_number}</td>
                    <td>{o.date}</td><td>{o.customer_name}</td>
                    <td>{o.product_name||'—'}</td><td>{o.quantity||'—'}</td>
                    <td>{o.expected_delivery||'—'}</td>
                    <td><span className="badge b-grey">{(o.status||'').replace('_',' ')}</span></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )}
      </div>
      {modal !== null && (
        <OrderModal customers={customers} products={products}
          onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />
      )}
    </div>
  );
}

function OrderModal({ customers, products, onClose, onSaved }) {
  const [form, setForm] = useState({ customer_id:'',product_id:'',quantity:'',customization_notes:'',expected_delivery:'' });
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    setSaving(true);
    try { await post('/orders', form); onSaved(); } finally { setSaving(false); }
  };
  return (
    <div className="modal-overlay"><div className="modal">
      <div className="modal-hdr">
        <span className="modal-title">New Order</span>
        <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
      </div>
      <div className="modal-body">
        <div className="form-group"><label className="form-label">Customer *</label>
          <select className="form-control" value={form.customer_id} onChange={e=>setForm({...form,customer_id:e.target.value})}>
            <option value="">Select customer</option>
            {customers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
          </select></div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Product</label>
            <select className="form-control" value={form.product_id} onChange={e=>setForm({...form,product_id:e.target.value})}>
              <option value="">Select product</option>
              {products.map(p=><option key={p.id} value={p.id}>{p.name}{p.size?' ('+p.size+')':''}</option>)}
            </select></div>
          <div className="form-group"><label className="form-label">Quantity</label>
            <input type="number" className="form-control" value={form.quantity} onChange={e=>setForm({...form,quantity:e.target.value})} /></div>
        </div>
        <div className="form-group"><label className="form-label">Expected Delivery</label>
          <input type="date" className="form-control" value={form.expected_delivery} onChange={e=>setForm({...form,expected_delivery:e.target.value})} /></div>
        <div className="form-group"><label className="form-label">Customization Notes</label>
          <textarea className="form-control" rows={3} value={form.customization_notes} onChange={e=>setForm({...form,customization_notes:e.target.value})} /></div>
      </div>
      <div className="modal-ftr">
        <button className="btn btn-outline" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving?'Saving...':'Create Order'}</button>
      </div>
    </div></div>
  );
}
